import {
  Column,
  Columns,
  Divider,
  Stack,
  Text,
} from "@origin-digital/ods-core";
import * as React from "react";
import { FormValues } from "../types";
import { useFormikContext } from "formik";
import FormContext from "src/context/FormContext";
import { format } from "date-fns";

const ReadOnlyCanRetailBlock = () => {
  const { values } = useFormikContext<FormValues>();
  const { formState } = React.useContext(FormContext);

  const handoverDate = formState.internetService?.handoverDate
    ? format(new Date(formState.internetService?.handoverDate), "dd/MM/yyyy")
    : "";

  return (
    <>
      <Stack
        space={{
          xs: "xlarge",
          md: "xlarge",
        }}
      >
        <Columns
          collapseBelow="md"
          space={{
            xs: "none",
            md: "xlarge",
          }}
          alignY="stretch"
        >
          <Column width="2/3">
            <Stack space="xsmall">
              <Stack space="xxsmall">
                <Text variant="body-small" tone="neutralLight">
                  LOC ID
                </Text>
                <Text>{values.locId}</Text>
              </Stack>
              <Divider />
            </Stack>
          </Column>
          <Column width="1/3" />
        </Columns>
        <Columns
          collapseBelow="md"
          space={{
            xs: "none",
            md: "xlarge",
          }}
          alignY="stretch"
        >
          <Column width="2/3">
            <Stack space="xsmall">
              <Stack space="xxsmall">
                <Text variant="body-small" tone="neutralLight">
                  Handover date
                </Text>
                <Text>{handoverDate}</Text>
              </Stack>
              <Divider />
            </Stack>
          </Column>
          <Column width="1/3" />
        </Columns>
        {values.internetNbnAddress && (
          <Columns
            collapseBelow="md"
            space={{
              xs: "none",
              md: "xlarge",
            }}
            alignY="stretch"
          >
            <Column width="2/3">
              <Stack space="xsmall">
                <Stack space="xxsmall">
                  <Text variant="body-small" tone="neutralLight">
                    Internet connection address
                  </Text>
                  <Text>{values.internetNbnAddress}</Text>
                </Stack>
                <Divider />
              </Stack>
            </Column>
            <Column width="1/3" />
          </Columns>
        )}
      </Stack>
    </>
  );
};

export default ReadOnlyCanRetailBlock;
